const CALENDAR_EVENTS = {
  UPDATE: 'update',
  SHOW_TOOLTIP: 'showTooltip',
};

export { CALENDAR_EVENTS };
